import axios from "axios";
import isEmpty from "lodash/isEmpty";

import { getHeader } from "../headers";

export const contentLoading = () => {
	return {
		type: "CONTENT_LOADING"
	};
};

export const contentHasError = err => {
	return {
		type: "CONTENT_HAS_ERROR",
		errors: err
	};
};

export const contentSuccess = data => {
	return {
		type: "CONTENT_SUCCESS",
		data
	};
};

export function getContent(permalink) {
	return dispatch => {
		dispatch(contentLoading());

		const params = { language: process.env.REACT_APP_LANGUAGE };

		return axios
			.get(process.env.REACT_APP_API_URL + "pages/" + permalink, {
				headers: getHeader(),
				params
			})
			.then(response => {
				// Error explicitly set
				if (!isEmpty(response.data.errors)) {
					dispatch(contentHasError(response.data.errors));

					// Error status
				} else if (!!response.data.status && response.data.status !== 200) {
					dispatch(contentHasError({ general: response.data.message }));

					// Success
				} else {
					dispatch(contentSuccess(response.data));
				}
			})
			.catch(err => {
				console.log("getContent error:", err.response);
				dispatch(contentHasError(err.response.data.message));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/content.js